import { z } from 'zod';
import { DataExport } from '../../../entities/dataExport';
import { AgeGroup, ChatRoomTypes, UserIdentity } from '../../../entities';
import { DateInputSchema } from '../../common';

export const PopulateVotesInputSchema = z.object({
    quarterId: z.string(),
});

export const DataExportInputTypeSchema = z.object({
    dataType: z.nativeEnum(DataExport),
    filters: z.object({
        userFilter: z
            .object({
                identity: z.nativeEnum(UserIdentity).optional(),
                ageGroup: z.nativeEnum(AgeGroup).optional(),
                isInStudy: z.boolean().optional(),
            })
            .optional(),
        quarterFilter: z
            .object({
                quarterNumber: z.number().optional(),
                setNumber: z.number().optional(),
            })
            .optional(),
    }),
});

export const DuplicateQuarterInputSchema = z.object({
    quarterId: z.string(),
    newQuarterNumber: z.number(),
    newSetNumber: z.number(),
    startDate: DateInputSchema,
});

export const GetChatRoomInputSchema = z.object({
    roomType: z.nativeEnum(ChatRoomTypes),
});

export const ReportChatMessageInputSchema = z.object({
    roomType: z.nativeEnum(ChatRoomTypes),
    messageId: z.string(),
    message: z.string(),
    senderId: z.string(),
    senderName: z.string(),
    timestamp: z.number().optional(), // Optional, as it might not be provided in all cases
});
